import { EnvsEnum } from '@utils/types';

import { buyActions, loginActions } from '@modules';
import { TMiddleware } from '@modules/types';

import { checkActionsType } from './utils';

const head = document.querySelector('head');
const script = document.createElement('script');

const url =
  CONST.env !== EnvsEnum.prod
    ? 'https://risk.sandbox.checkout.com/cdn/risk/1/risk.js'
    : 'https://risk.checkout.com/cdn/risk/1/risk.js';

const INTERVAL = 20 * 60 * 1000;

let risk;
let isFirstLoad = true;

const updateDeviceSessionId = async () => {
  window.deviceSessionId = await risk?.publishRiskData();
};

const checkout: TMiddleware = () => next => action => {
  if (checkActionsType(action, [loginActions.keepAlive.fulfilled]) && isFirstLoad) {
    isFirstLoad = false;
    script.setAttribute('src', url);
    script.addEventListener('load', async () => {
      risk = window.Risk.init(CONST.checkoutPublicKey);
      updateDeviceSessionId();
      window.setInterval(updateDeviceSessionId, INTERVAL);
    });
    head?.appendChild(script);
  }

  return next(action);
};

export default checkout;
